/**
 * 文件说明:
 *
 * global header
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {useCallback, useMemo, useRef} from 'react'
import GlobalHeader from 'components/hz-layout/global-header'
import {useSafeState, useShallowEqualSelector} from 'hooks'
import {useDispatch} from 'umi'
import {LogoutOutlined} from '@ant-design/icons'
import {Menu, Dropdown} from 'antd'
import {findInnerChild} from 'utils'
import config from 'config'
import {isWxwork} from 'utils/wx'
import {globalLayoutContext} from './context'
import downSvg from './images/down.svg'
import helpSvg from './images/help.svg'
import styles from './index.less'

function Header({children}) {
    const dispatch = useDispatch()

    const {tree, initData} = useShallowEqualSelector(({menu, auth}) => ({
        tree: menu.tree,
        initData: auth.initData,
    }))

    const [hzHeaderHelp, setRawHzHeaderHelp] = useSafeState(config.initHzHeaderHelp)

    const getLinkTo = useCallback((item = {}) => findInnerChild(item), [])

    const prevHzHeaderHelpRef = useRef(config.initHzHeaderHelp)

    const setHzHeaderHelp = useCallback(
        (hzHelp) => {
            if (hzHelp) {
                setRawHzHeaderHelp((prevHzHeaderHelp) => {
                    prevHzHeaderHelpRef.current = prevHzHeaderHelp
                    return hzHelp
                })
            }
        },
        [setRawHzHeaderHelp],
    )

    const restoreHzHeaderHelp = useCallback(() => {
        setRawHzHeaderHelp(prevHzHeaderHelpRef.current)
    }, [setRawHzHeaderHelp])

    const menus = useMemo(
        () =>
            tree.map((item) => {
                if (item.isExternal) {
                    return item
                }

                return {
                    key: `barNav-${item.id}`,
                    to: getLinkTo(item),
                    isActive: (match, location) => location?.pathname?.includes(`/${item.slug}`),
                    name: item.name,
                }
            }),
        [getLinkTo, tree],
    )

    const onMenuClick = useCallback(
        ({key}) => {
            if (key === 'logout') {
                dispatch({
                    type: 'auth/logout',
                })
            }
        },
        [dispatch],
    )

    const menu = useMemo(
        () => (
            <Menu className={styles.menu} selectedKeys={[]} onClick={onMenuClick}>
                <Menu.Item key="logout">
                    <LogoutOutlined />
                    退出登录
                </Menu.Item>
            </Menu>
        ),
        [onMenuClick],
    )

    const RightContent = useMemo(
        () => (
            <>
                {hzHeaderHelp && (
                    <a href={hzHeaderHelp} target="_blank" rel="noreferrer">
                        <img className={styles.help} src={helpSvg} alt="help" />
                    </a>
                )}
                {isWxwork() ? (
                    <span className={styles.name}>{initData?.user?.name ?? ' '}</span>
                ) : (
                    <Dropdown overlay={menu}>
                        <span>
                            <span className={styles.name}>{initData?.user?.name ?? ' '}</span>
                            <img className={styles.down} src={downSvg} alt="down" />
                        </span>
                    </Dropdown>
                )}
            </>
        ),
        [initData, menu, hzHeaderHelp],
    )

    return (
        <>
            <GlobalHeader
                menus={menus}
                RightContent={RightContent}
                companyName={initData?.company?.name ?? ''}
            />
            <globalLayoutContext.Provider
                value={{
                    restoreHzHeaderHelp,
                    setRawHzHeaderHelp,
                    setHzHeaderHelp,
                    hzHeaderHelp,
                }}
            >
                {children}
            </globalLayoutContext.Provider>
        </>
    )
}

export default Header
